export default __webpack_public_path__ + "static/icecream-taste-3-desktop-7f7bbc8cf25397bc98634d0bb7056f57.png";